import { FooterContext } from "@contexts/FooterContext";
import hasSameOrigin from "@utils/hasSameOrigin";
import React, { useContext } from "react";
import { FooterColumn } from "src/assets/Types/Redesign/FooterDataType.type";

type ColumnFooterType = {
  isLast: boolean;
  item: FooterColumn;
};

const ColumnFooter: React.FC<ColumnFooterType> = ({ item }) => {
  const underlineClass = `relative no-underline text-forest-900 w-max inline-block hover:after:content-[''] hover:after:inline-block hover:after:w-full hover:after:h-[1.5px] hover:after:bg-forest-900 hover:after:absolute hover:after:left-0 hover:after:bottom-[-2px]`;

  const { onClick } = useContext(FooterContext);

  return (
    <div className={`flex flex-col gap-4`}>
      <span className="body--text-regular !font-bold">{item?.title}</span>
      <div className="flex flex-col gap-3">
        {item?.footerLinks?.map((item, key) => {
          const url = item?.page?.value?.data?.url || item?.url;
          const target = hasSameOrigin(url) ? "_self" : "_blank";

          return (
            <a
              key={key}
              className={underlineClass}
              href={url}
              onClick={onClick}
              target={target}
            >
              {item?.copy}
            </a>
          );
        })}
      </div>
      {item?.extraColumn && (
        <div className={`flex flex-col gap-4 pt-6 md:pt-0`}>
          <span className="body--text-regular !font-bold">
            {item?.extraColumn?.title}
          </span>
          <div className="flex flex-col gap-3">
            {item?.extraColumn?.footerLinks?.map((itemExtraColumn, key) => {
              const url =
                itemExtraColumn?.page?.value?.data?.url || itemExtraColumn?.url;
              const target = hasSameOrigin(url) ? "_self" : "_blank";

              return (
                <a
                  target={target}
                  key={key}
                  className={underlineClass}
                  href={
                    itemExtraColumn?.page?.value?.data?.url ||
                    itemExtraColumn?.url
                  }
                  onClick={
                    itemExtraColumn.url?.includes("http") ? () => {} : onClick
                  }
                  rel="noreferrer"
                >
                  {itemExtraColumn?.copy}
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnFooter;
